import { useParams } from 'react-router-dom';

import { useQuery } from '@tanstack/react-query';
import { getPublisherIdByPortalId } from 'utils/portalUtils';

import { EQueryKeys } from '../constants/enums';
import useAxios from '../hooks/useAxios';

import {
  EApiRoutes,
  getApiRouteOrMock
} from './api.utils';
import { useUserDetails } from './useUserDetails';

export default function useRoles() {
  const axios = useAxios();
  const { publisherId, portalId } = useParams();
  const { userDetails } = useUserDetails();

  const effectivePublisherId = publisherId || (portalId ? getPublisherIdByPortalId(portalId, userDetails) : undefined);
  const publisherHeader = effectivePublisherId ? { 'x-publishers': effectivePublisherId } : undefined;

  const getRoles = useQuery<any, Error>({
    retry: false,
    queryKey: [EQueryKeys.ROLES, effectivePublisherId],
    queryFn: async () => {
      return await axios.get(
        `${getApiRouteOrMock(EApiRoutes.ROLES)}`,
        {},
        publisherHeader
      );
    },
    enabled: !!effectivePublisherId
  });

  return {
    getRoles
  };
}
